import { render, staticRenderFns } from "./AddCoinQtyBtn.vue?vue&type=template&id=3836dfe2&"
import script from "./AddCoinQtyBtn.vue?vue&type=script&lang=js&"
export * from "./AddCoinQtyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports